import { render, staticRenderFns } from "./MenuGrundlagen.vue?vue&type=template&id=07abde08&scoped=true&"
import script from "./MenuGrundlagen.vue?vue&type=script&lang=js&"
export * from "./MenuGrundlagen.vue?vue&type=script&lang=js&"
import style0 from "./MenuGrundlagen.vue?vue&type=style&index=0&id=07abde08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07abde08",
  null
  
)

export default component.exports